import React from 'react'
import Typography from '@material-ui/core/Typography';

const OperatingRoom = () => (
  <Typography component="h1" variant="h4">Operating Room</Typography>
)

export default OperatingRoom;
